<template>
  <div class="flex flex-col">
    <div class="grid grid-cols-1 m-2"><!-- md:grid-cols-4 lg:grid-cols-6"> -->
      <!-- <div>
        <span class="font-bold">
          First Name:
        </span>
        {{ inputData.firstName }}
      </div>
      <div>
        <span class="font-bold">
          Middle Name:
        </span>
        {{ inputData.middleName }}
      </div>
      <div>
        <span class="font-bold">
          Last Name:
        </span>
        {{ inputData.lastName }}
      </div>
      <div>
        <span class="font-bold">
          Student ID:
        </span>
        {{ inputData.studentId }}
      </div> -->
      <div>
        <span class="font-bold">
          Date of Birth:
        </span>
        {{ dateOfBirth }}
      </div>
      <div>
        <span class="font-bold">
          Grade:
        </span>
        {{ grade }}
      </div>
      <div>
        <span class="font-bold">
          Gender:
        </span>
        {{ gender }}
      </div>
    </div>
    <span class="font-bold mx-2 mt-2">
      Contacts:
    </span>
    <Contacts class="m-2 bg-gray-200 rounded-md p-2"
      :contacts="inputData.contacts"
    />
    <span class="font-bold mx-2 mt-2">
      Addresses:
    </span>
    <div class="grid grid-cols-1 justify-items-center m-2 md:grid-cols-2 bg-gray-200 rounded-md p-2">
      <div class="md:col-span-2">
        <Address
          addressDisplay="Home:"
          :address="inputData.address"
        />
      </div>
      <div
        v-if="inputData.pickupAddress">
        <Address
          addressDisplay="Pickup:"
          :address="inputData.pickupAddress"
        />
      </div>
      <div
        v-else>
        <span class="font-bold">---</span>
      </div>
      <div
        v-if="inputData.dropoffAddress">
        <Address
          addressDisplay="Dropoff:"
          :address="inputData.dropoffAddress"
        />
      </div>
      <div
        v-else>
        <span class="font-bold">---</span>
      </div>
    </div>
    <span class="font-bold mx-2 mt-2"
      v-if="inputData.building">
      Building:
    </span>
    <div class="grid grid-cols-1 gap-2 m-2 md:grid-cols-3 bg-gray-200 rounded-md p-2"
      v-if="inputData.building">
      <div>
        <span class="font-bold">
          Name:
        </span>
        {{ inputData.building.name }}
      </div>
      <div class="md:col-span-2">
        <Address
        addressDisplay="Address:"
          :address="inputData.building.address"
        />
      </div>
    </div>
  </div>
</template>
<script>
import DropdownLists from '../components/DropdownLists.json'

import Contacts from './StudentHistory/common/Contacts.vue'
import Address from './StudentHistory/common/Address.vue'

export default {
  components: {
    Contacts,
    Address
  },
  props: {
    inputData: {},
  },
  data() {
    return {
      displayList: {},
    }
  },
  methods: {
    remapDetailList(inputData) {
      var fieldNameRemaps = {
        studentId: 'Student ID',
        firstName: 'First Name',
        middleName: 'Middle Name',
        lastName: 'Last Name',
        dateOfBirth: 'Date of Birth',
        gender: 'Gender',
        grade: 'Grade',
        language: 'Language',
        infoAide: 'Aide',
        infoWheelchair: 'Wheelchair',
        infoSolo: 'Require Solo Transport',
        infoBoosterSeat: 'Require Booster Seat',
        infoSafetyVest: 'Require Safety Vest',
        infoCarSeat: 'Require Car Seat',
        studentRelease: 'Student Release',
        marssCode: 'MARSS Code',
        program: 'Program',
        schedule: 'Schedule',
        building: 'School',
        address: 'Home Address',
        pickupAddress: 'Pick-up Address',
        dropoffAddress: 'Drop-off Address',
        contacts: 'Contacts',
        startDate: 'Start Date',
        endDate: 'Last Day of Transportation',
        arrivalTime: 'Arrival Time',
        programStartTime: 'Program Start Time',
        programEndTime: 'Program End Time',
        departureTime: 'Departure Time',
        medicalInfo: 'Medical Information',
      }

      function addressRemap(address) {
        if (!address) {
          return ''
        }
        if (address.apartment) {
          return `${address.street}, apt. ${address.apartment}, ${address.city}, ${address.state}, ${address.zip_code}`
        } else {
          return `${address.street}, ${address.city}, ${address.state}, ${address.zip_code}`
        }
      }

      var fieldFunctionRemaps = {
        building: function (building) {
          if (!building) return ''

          return {
            name: building.name,
            address: addressRemap(building.address),
          }
        },
        address: addressRemap,
        pickupAddress: addressRemap,
        dropoffAddress: addressRemap,
        infoAide: function (aide) {
          if (aide == 'A') return 'Aide Required'
          else if (aide == 'A1:1') return 'One-to-one Aide Required'
          else return 'N/A'
        },
        grade: function (grade) {
          return DropdownLists.gradeList[grade]
        },
      }

      var outputData = {}

      for (const field in inputData) {
        if (field in fieldNameRemaps) {
          if (field in fieldFunctionRemaps) {
            outputData[fieldNameRemaps[field]] = fieldFunctionRemaps[field](
              inputData[field]
            )
          } else {
            outputData[fieldNameRemaps[field]] = inputData[field]
          }
        }
      }

      return outputData
    },
  },
  mounted() {
    this.displayList = this.remapDetailList(this.inputData)
  },
  computed: {
    grade() {
      if (this.inputData.grade) {
        return DropdownLists.gradeList[this.inputData.grade]
      }
      else {
        return ''
      }
    },
    gender() {
      if (this.inputData.gender) {
        return DropdownLists.genderList[this.inputData.gender]
      }
      else {
        return ''
      }
    },
    dateOfBirth() {
      if (this.inputData.dateOfBirth) {
        return new Date(this.inputData.dateOfBirth).toLocaleString(
          'en-US',
          {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            timeZone: 'UTC',
          }
        )
      }
      else {
        return ''
      }
    },
  }
}
</script>
